import OriginalDatePicker from './DateInput.svelte';
import Label from './Label.svelte';
import Icon from '../icon/Icon.svelte';
const DatePicker = OriginalDatePicker;
DatePicker.Label = Label;
DatePicker.Leading = Icon;
DatePicker.Trailing = Icon;
export default DatePicker;
